// Add your custom JS here.

// Accessibility audit (2 Oct 2026): the CM Answers Pro resources search
// widget renders its submit button as a bare icon with no text, aria-label
// or title, so screen readers announce only "button" with no indication of
// what it does (WCAG 4.1.2 Name, Role, Value). This is plugin markup, not a
// theme template, so the accessible name is set here instead of patching
// the plugin directly.
document.querySelectorAll('#cma-ajax-search button[type="submit"]').forEach(function (btn) {
	if (!btn.hasAttribute('aria-label')) {
		btn.setAttribute('aria-label', 'Search');
	}
});